/**
 * Прогрев кеша чанков после первой установки service worker (план 21.09, п.3).
 *
 * На чистом визите SW ставится параллельно с загрузкой движка, и чанки,
 * пришедшие до того, как он взял страницу, в кеш `app-assets` не попадают —
 * оффлайн «работал со второго раза». Когда контроллер появился впервые,
 * перезапрашиваем уже загруженные /assets/*.js|css и данные площадки
 * (venue.json, occupants.json) через SW: ответы идут из HTTP-кеша браузера
 * (дёшево), а runtime-правила кладут их в Cache Storage.
 */
const WARM_RE =
  /\/(?:assets\/[\w.-]+\.(?:js|css)|venues\/[\w-]+\.venue\.json|v\/[\w-]+\/occupants\.json)$/

/** Чанк движка мог быть ещё в полёте в момент захвата страницы — добираем позже. */
const LATE_CHUNKS_DELAY_MS = 8000

/** URL загруженных чанков и данных площадки своего origin без дублей (чистая функция — для тестов). */
export function loadedAssetUrls(entries: readonly { name: string }[], origin: string): string[] {
  const urls = entries.map((e) => e.name).filter((u) => u.startsWith(origin) && WARM_RE.test(u))
  return [...new Set(urls)]
}

function refetchLoadedAssets(): void {
  const urls = loadedAssetUrls(performance.getEntriesByType('resource'), location.origin)
  for (const url of urls) void fetch(url).catch(() => undefined)
}

export function warmAssetCacheAfterInstall(): void {
  refetchLoadedAssets()
  setTimeout(refetchLoadedAssets, LATE_CHUNKS_DELAY_MS)
}
